export function populatePath(path, params, query = {}) {
  return `${path
    .split('/')
    .map((tok) => (tok.startsWith(':') ? params[tok.replace(/^:/, '')] : tok))
    .join('/')}${query?.IdSite ? '?IdSite=' + query.IdSite : ''}`;
}
